import { useState, useContext, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { loadingContext, loginContext } from '../../Context';
import { EmotionPredictionList } from '../PredictionResultTable/PredictionResultTable';
import MongoRequestHandler from '../../helpers/MongoRequestHandler';
import Loader from "../NavBar/Loader/Loader";

export default function StudySummary({title, historyLimit, predLimit, history_source}) {
    const loadingCtx = useContext(loadingContext);
    const isLoading = loadingCtx.state.isLoading;
    const [isErrorLoadingHistory, setIsErrorLoadingHistory] = useState(false);
    const [processingHistory, setProcessingHistory] = useState([]);

    const loginCtx = useContext(loginContext);
    const isLoggedIn = loginCtx.state.isLoggedIn;

    const [refreshHistory, setRefreshHistory] = useState(true);

    const BLANK_IMAGE = `R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==`;

    useEffect(() => {
        if (isLoggedIn && refreshHistory) {
            setIsErrorLoadingHistory(false);
            loadingCtx.dispatch({ type: "on" });

            try {
                new MongoRequestHandler().fetchProcessHistory(loginCtx.state.username, history_source, historyLimit).then((data) => {
                    setProcessingHistory(data);
                    setRefreshHistory(false);
                    loadingCtx.dispatch({ type: "off" });
                });
            } catch (error) {
                console.error('Error loading processing history:', error);
                setIsErrorLoadingHistory(true);
                loadingCtx.dispatch({ type: "off" });
            }
        }
    }, [isLoggedIn, refreshHistory]);

    return (
        <Container className="study-item">
            <Row>
                <h1 style={{ fontWeight: 'bold' }}>{title}</h1>
                <Container>
                    {
                        isLoggedIn ? ( 
                                !isLoading ? (
                                    !isErrorLoadingHistory && processingHistory && processingHistory.length > 0 ? (
                                        <Row>
                                            {processingHistory.map((entry, index) => (
                                                <Col key={index} lg={3} md={6} sm={12} className="d-flex flex-column align-items-center">
                                                    <div className="grid-item">
                                                        <h5 className="text">Input</h5>
                                                        <img src={entry.annotated_image.includes(BLANK_IMAGE) ? entry.input_image : entry.annotated_image} className="visualization-images" alt="Original" />
                                                        {/* <img src={entry.input_image} className="visualization-images" alt="Original" /> */}
                                                    </div>
                                                    <div className="grid-item" style={{width:"95%"}}>
                                                        <EmotionPredictionList predictions={entry.emo_pred} showFirstCount={predLimit} fontSize={1} maxHeight="13vh" />
                                                    </div>
                                                </Col>
                                            ))}
                                        </Row>
                                    ) : (
                                        <span>Error loading {title}, please check server</span>
                                    )
                                ) : (
                                    <>
                                        <span>Please wait while EmoAI is preparing your {title}</span>
                                        <Loader />
                                    </>
                                )
                        ) : (
                            <span>Please log in to record and view your {title}</span>
                        )
                    }
                </Container>
            </Row>
        </Container>
    );
}
